export default {
  Discard: -1,
  Proposed: 0,      // Auto-generated from inspection and complaints and not saved in database
  Assigned: 1,   // It becomes a task that has to be done
  Performed: 8,     // The fix is finished and invoice uploaded (if so)
  Closed: 9,        // Case closed
}
